<template>
  <div class="scrm-input">
    <el-input v-bind="$attrs">
      <template #prepend>{{ leftTitle }}</template>
    </el-input>
  </div>
</template>

<script>
export default {
  inheritAttrs: true,
  name: "scrm-input",
  props: {
    leftTitle: {
      //左边的标题
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
:deep(.el-input-group__prepend) {
  background: #fff;
  padding: 0 10px;
  box-shadow: none;
  border: 1px solid #e6e6e6;
  border-right: 0;
}

:deep(.el-input__wrapper) {
  box-shadow: none !important;
  border: 1px solid #e6e6e6;
  border-left: 0;
}

:deep(.el-input-group__prepend) {
  color: #666;
}

:deep(.el-input__inner) {
  color: #333;
}
</style>
